<style lang="scss" scoped>
::v-deep .checkbox {
	margin: 0;
	align-items: flex-start;
	.van-checkbox__icon {
		position: relative;
		top: 0.06rem;
		border-radius: 0.06rem;
		.van-icon {
			border-radius: 0.06rem;
		}
		padding-right: 0.2rem;
	}
	.van-checkbox__label {
		font-size: 0.24rem;
		line-height: 0.36rem;
		color: $font_color_thd;
		margin-left: 0;
	}
}
.is_link {
	color: $color_main;
}

::v-deep .must_read_pop {
	.van-action-sheet__content {
		overflow: hidden;
	}
}
.must_read_content {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0 0.3rem 0.3rem;
	height: 60vh;
	box-sizing: border-box;
	.content_info {
		height: 41vh;
		overflow-y: scroll;
		word-break: break-all;
		
	}

	::v-deep p{
		font-size: 0.24rem;
	}

	::v-deep h1{
		font-size: 0.26rem !important;
	}
	.content {
		flex: 1;
		overflow-y: auto;
	}
	.loading_btn_box {
		width: 100%;
		padding: 0.2rem 0.3rem;
		box-sizing: border-box;
		.loading_btn {
			border-radius: 8px;
			height: 0.8rem;
		}
	}
}

	

.must_read_pop {
	z-index: 3001 !important;
	.loading_btn_content {
		display: flex;
		align-items: center;
		.time {
			color: #fff;
			margin-left: 0.4rem;
		}
	}
}
.clause_title {
	font-size: 0.28rem;
	color: $color_main;
	margin: 0.3rem 0 0.1rem;
	font-weight: bold;
}
.clause_text {
	font-size: 0.24rem;
	padding: 0.1rem;
	a {
		color: $font_color_main;
	}
}
.mb_2 {
	margin-bottom: 0.2rem;
}
.other_tip{
	background-color: #cee4f8;
	color: $color_main;
	font-size: 0.26rem;
	border-radius: 0.2rem;
	padding: 0.2rem;
	margin-top: 0.3rem;
}
.insurance_tip{
	font-size: 0.24rem;
	.hint_title{
		font-weight: bold;
		padding: 10px 0;
	}
}

.flex_normal{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}

.block{
	color: #fff;
}


</style>

<template>
	<div class="clause_info">
		<div class="card_box">
			<van-checkbox class="checkbox mb_2" v-model="rule_1" @change="checkChange" shape="square" icon-size="0.28rem" label-disabled>
				<div class="flex_normal">
					<span @click="rule_1 = !rule_1">请仔细阅读并同意</span>
					<span @click="handleOpen">
						<span class="is_link per_rule" v-text="$t('insureHint')">《投保提示》</span>
						<span class="is_link" v-text="$t('liabilityContent')">《免责内容》</span>
						<span class="is_link" v-text="$t('insuredAgrees')">《被保险人同意声明》</span>
						<span class="is_link" v-text="$t('insuranceClause')">《保险条款》</span>
						<span class="is_link" v-text="$t('insuranceDeclaration')">《投保声明》</span>
						<span class="is_link per_rule" v-text="$t('userInfoProtect')">《个人信息保护政策》</span>
					</span>
				</div>
			</van-checkbox>
		</div>
		<!-- <bottom-info-pop v-model="infoPopShow" :title="infoPopTitle" :content="infoPopContent"></bottom-info-pop> -->

		<van-action-sheet v-model="mustReadPopShow" class="must_read_pop" title="请仔细阅读以下内容" >
			<div class="must_read_content">
				<div class="tabs">
					<van-tabs v-model="mustReadIndex" color="#409EFF" title-active-color="#409EFF" @change="changeTabs">
						<van-tab class="text" title="投保提示" :disabled="isReading && !isReadList.includes(0)">
							<div class="content_box">
								<div class="content_info"  v-scroll-bottom:100="handleScrollBottom">
									<div class="insurance_tip" v-if="Array.isArray(information.insuranceTip)">
											<div v-for="(item,index) in information.insuranceTip" :key="index">
												<div class="hint_title" v-html="item.title"></div>
												<div v-html="item.content"></div>
											</div>
									</div>
									<div v-else v-html="information.insuranceTip"></div>
								</div>
								<div class="tip_read  "><span v-if="!isCountDown&&isTop&&!rule_1">请滑动并阅读到底部</span></div>
								<van-button style="width: 100%;border-radius: 8px;" type="info" @click="nextDoc" :disabled="(isTop&&!rule_1)||isCountDown">
									<div class="flex_normal">
										{{ $t('iagree') }}{{ $t('insurePrompt') }} 
										<van-count-down v-if="isCountDown&&mustReadIndex==0" ref="countDown" class="time" :time="0" @finish="finish">
											<template #default="timeData">
												<span class="block">{{ timeData.seconds }}{{ $t('sec') }}</span>
											</template>
										</van-count-down>
									</div>
								</van-button>
							</div>
						</van-tab>
						<van-tab title="免责内容" :disabled="isReading && !isReadList.includes(1)">
							<div class="content_info"   v-scroll-bottom:100="handleScrollBottom">
								<div v-html="information.preventDuty"></div>
							</div>
							<div class="tip_read  "><span v-if="!isCountDown&&isTop&&!rule_1">请滑动并阅读到底部</span></div>
							<van-button style="width: 100%;border-radius: 8px;" type="info" @click="nextDoc" :disabled="(isTop&&!rule_1)||isCountDown">
								<div class="flex_normal">
									{{ $t('iagree') }}{{ $t('liabilityContent') }}
									<van-count-down v-if="isCountDown&&mustReadIndex==1" ref="countDown" class="time" :time="0" @finish="finish">
										<template #default="timeData">
											<span class="block">{{ timeData.seconds }}{{ $t('sec') }}</span>
										</template>
									</van-count-down>
								</div>
							</van-button>
						</van-tab>
						<van-tab title="被保险人同意声明" :disabled="isReading && !isReadList.includes(2)">
							<div class="content_info"  v-scroll-bottom:100="handleScrollBottom">
								<div v-html="information.insuredDeclare" ></div>
							</div>
							<div class="tip_read  "><span v-if="!isCountDown&&isTop&&!rule_1">请滑动并阅读到底部</span></div>
							<van-button style="width: 100%;border-radius: 8px;" type="info" @click="nextDoc" :disabled="(isTop&&!rule_1)||isCountDown">
								<div class="flex_normal">
									{{ $t('iagree') }}{{ $t('insuredAgrees') }}
									<van-count-down v-if="isCountDown&&mustReadIndex==2" ref="countDown" class="time" :time="0" @finish="finish">
										<template #default="timeData">
											<span class="block">{{ timeData.seconds }}{{ $t('sec') }}</span>
										</template>
									</van-count-down>
								</div>
							</van-button>
						</van-tab>
						<van-tab title="保险条款" :disabled="isReading && !isReadList.includes(3)">
							<div class="content_info">
								<div class="clause_title">主条款</div>
								<div class="clause_text" v-for="item in information.mainClausesList" :key="item.docLink">
									<a :href=" item.link">{{ item.docName }}</a>
								</div>
								<div class="clause_title">附加条款</div>
								<div class="clause_text" v-for="item in information.additionClausesList" :key="item.docLink">
									<a :href="item.link">{{ item.docName }}</a>
								</div>
							</div>
							<van-button @click="nextDoc" style="width: 100%;border-radius: 8px;" type="info">{{ $t('iagree') }}{{ $t('insuranceClause') }}</van-button>
						</van-tab>
						<van-tab title="投保声明" :disabled="isReading && !isReadList.includes(3)">
							<div class="content_info" v-html="information.f1FixedInfo"></div>
							<van-button @click="nextDoc" style="width: 100%;border-radius: 8px;" type="info">{{ $t('iagree') }}{{ $t('insuranceDeclaration') }}</van-button>
						</van-tab>
						<van-tab title="个人信息保护政策" :disabled="isReading && !isReadList.includes(3)">
							<div class="content_info" v-html="information.f3FixedInfo"></div>
							<van-button @click="nextDoc" style="width: 100%;border-radius: 8px;" type="info">{{ $t('iagree') }}{{ $t('userInfoProtect') }}</van-button>
						</van-tab>
					</van-tabs>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>

<script>
import { Checkbox, ActionSheet, Button, CountDown, Toast, Tab, Tabs } from 'vant';

export default {
	name: 'confirmBookClauseInfo', // 条款信息
	components: {
		[Checkbox.name]: Checkbox,
		[ActionSheet.name]: ActionSheet,
		[Button.name]: Button,
		[CountDown.name]: CountDown,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Toast.name]: Toast,
	},
	props: {
		information: {
			type: Object,
			required: true,
		},
	
	},
	data() {
		return {
			// 条款
			rule_1: false,
			// 投保声明、个人信息保护政策内容
			infoPopShow: false,
			infoPopTitle: '',
			infoPopContent: '',
			mustReadPopShow: false,
			mustReadIndex: 0,
			isReading: true,
			isFirst: false,
			isReadList: [0],
			isTop: true,
			isCountDown:true,
		};
	},

	methods: {
		getResult() {
			if (!this.rule_1) {
				Toast('请先勾选条款');
			}
			return this.rule_1;
		},
		nextDoc() {
			this.isTop = false;
			if (this.mustReadIndex < 3) {
				this.isTop = true;
				if (!this.isReadList.includes(this.mustReadIndex + 1)) {
					this.isReadList.push(this.mustReadIndex + 1);
				}
				this.$nextTick(() => {
					this.mustReadIndex = this.mustReadIndex + 1;
					if(!this.rule_1){
						this.isCountDown = true;
						this.$refs.countDown?.reset();
					}
				});
				this.isReading = true;
			} else {
				this.isReading = false;
				this.mustReadPopShow = false;
				this.mustReadIndex = 0;
				this.rule_1 = true;
			}
		},

		finish() {
			this.isCountDown = false;
		},
		handleOpen() {
			this.mustReadPopShow = true;
			this.mustReadIndex = 0;
			if(this.rule_1){
				this.isCountDown = false
			}else{
				this.isCountDown = true
			}
		},

		// 勾选改变
		checkChange() {
			if (this.isReading) {
				this.rule_1 = false;
				this.mustReadPopShow = true;
				this.countDown = false
			}
		},

		changeTabs(){
			if(!this.rule_1){
				this.isTop = true;
			}
		},

		handleScrollBottom(){
				this.isTop = false;
		}
	},
};
</script>
